import {AfterViewInit, Component, HostListener, inject, OnDestroy} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from '@angular/router';
import {filter, Subscription} from 'rxjs';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrl: './features.component.scss',
    standalone: true,
    imports: [
        RouterLink
    ]
})
export class FeaturesComponent implements AfterViewInit, OnDestroy {

    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private subscription: Subscription;

    showBackToTop = false;

    ngAfterViewInit() {
        // Handle initial fragment if present
        setTimeout(() => {
            this.scrollToFragment(this.route.snapshot.fragment);
        }, 100);

        // Handle fragment changes during navigation
        this.subscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            setTimeout(() => {
                this.scrollToFragment(this.route.snapshot.fragment);
            }, 100);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    @HostListener('window:scroll')
    onWindowScroll() {
        // Show the button when the user scrolls down 300px from the top
        this.showBackToTop = window.scrollY > 300;
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    private scrollToFragment(fragment: string) {
        if (!fragment) return;

        const element = document.getElementById(fragment);
        if (element) {
            // Add offset to account for fixed navigation bar
            const yOffset = -80; // Adjust this value based on the height of your navbar
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }
}
